import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  @Output() formData: EventEmitter<{
    email: string;
    password: string;
    companyCode: string;
  }> = new EventEmitter();

  loginForm: UntypedFormGroup;
  apiUrl = environment.apiUrl;

  companyCodes: string[] = [];

  showRoleField: boolean = false;

  requireCompanyCode: boolean = true;

  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.api.getAllCompanyCodes().subscribe({
      next: (codes) => {
        this.companyCodes = codes;
      },
      error: (err) => {
        console.error('Error fetching company codes:', err);
        this.companyCodes = ['HTC', 'CSN'];
      },
    });
    this.loginForm = this.fb.group({
      companyCode: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  get companyCode() {
    return this.loginForm.get('companyCode');
  }

  onEmailFocusOut() {
    const emailValue: string = this.loginForm.get('email')?.value;
    this.loginForm.get('email')?.setValue(emailValue.trim());

    this.checkUserRole(emailValue.trim());
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.formData.emit(this.loginForm.value);
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  checkUserRole(email: string) {
    // Call your API or service to check the user role based on the email
    this.api.checkUserRoleByEmail(email).subscribe({
      next: (role) => {
        if (
          role === 'Estimator' ||
          role === 'Foreman' ||
          role === 'Service Tech'
        ) {
          this.requireCompanyCode = false;
          // Clear and disable the company code field
          this.loginForm.get('companyCode')?.reset();
          this.loginForm.get('companyCode')?.disable();
          this.loginForm.get('companyCode')?.clearValidators();
          this.loginForm.get('companyCode')?.updateValueAndValidity();
        } else {
          this.requireCompanyCode = true;
          // Enable and set validators for the company code field
          this.loginForm.get('companyCode')?.enable();
          this.loginForm.get('companyCode')?.setValidators(Validators.required);
          this.loginForm.get('companyCode')?.updateValueAndValidity();
        }
      },
      error: (err) => {
        console.error('Error checking user role:', err);
      },
    });
  }
}
